import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const InvisibleCell = styled(TableCell)({
  backgroundColor: "transparent",
});
